import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dca6152"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-item" }
const _hoisted_2 = { class: "notice-item-content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "notice-item-detail" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "展开", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "收起", -1))
const _hoisted_7 = { class: "notice-item-time" }

import {computed, onMounted, ref} from "vue";
import {ArrowDown, ArrowUp} from "@element-plus/icons-vue";

interface props {
  data?: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeItem',
  props: {
    data: { default: {
    title: '',
    content: '',
    createtime: ''
  } }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "a3216ae6": (maxHeight.value)
}))

const props = __props;

const content = ref({...props.data, ...{isOpen: false, show: false}});

/**
 * 是否添加隐藏类名
 */
const close = computed(() => {
  return !content.value.isOpen ? 'close' : '';
})

/**
 * 切换显示隐藏
 */
const toggleOpen = () => {
  content.value.isOpen = !content.value.isOpen;
}

/**
 * 折叠起来的最大高度
 */
const height = ref(0.2)
const maxHeight = computed(() => height.value + 'rem');

const contentRef = ref()
onMounted(() => {
  const elHeight = contentRef.value?.clientHeight;
  content.value.show = elHeight / 100 > height.value;
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(['title',  close.value])
      }, _toDisplayString(content.value.title), 3),
      _createElementVNode("div", {
        class: _normalizeClass(['content-wrap', close.value])
      }, [
        _createElementVNode("div", {
          innerHTML: content.value.content,
          class: "content",
          ref_key: "contentRef",
          ref: contentRef
        }, null, 8, _hoisted_3)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (content.value.show)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            class: "open-btn",
            onClick: toggleOpen
          }, {
            default: _withCtx(() => [
              (!content.value.isOpen)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_5,
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowDown))
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_6,
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowUp))
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, _toDisplayString(content.value.createtime), 1)
    ])
  ]))
}
}

})